import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { QuestionnaireEdit } from "@/features/catalog";
import { questionnaireDefinitionRouteId } from "@/features/catalog/lib/questionnaire-definition-route";

export const Route = createFileRoute("/catalog/questionnaires/new")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canWrite("Questionnaire")) {
      throw redirect({ to: "/catalog/questionnaires" });
    }
  },
  component: NewQuestionnaireComponent,
});

function NewQuestionnaireComponent() {
  const navigate = useNavigate();
  const backToQuestionnaires = () => navigate({ to: "/catalog/questionnaires" });
  const toCreated = (url?: string) =>
    url
      ? navigate({
          to: "/catalog/questionnaires/$questionnaireId",
          params: { questionnaireId: questionnaireDefinitionRouteId(url) },
        })
      : backToQuestionnaires();

  return <QuestionnaireEdit canEdit onDone={toCreated} onCancel={backToQuestionnaires} />;
}
